'use client';

import { GetResponseType } from '@/api/types/api';
import { ApiResponseDefinition } from '@/api/types/api-definition';
import { useReporting } from '@/hooks/useReporting';
import { useRouteMetadata } from '@/hooks/useRouteMetadata';
import { useStore } from '@/providers/app-store-provider';
import { ProviderType } from '@/reporting';
import { useEffect } from 'react';
import MobileMenuItem from './MenuItem.m';
import SiteConfig from './SiteConfig';

export interface SideNavProps {
  navData: GetResponseType<ApiResponseDefinition['GET:/api/nav/lists']>;
}

// 菜单的层级关系是：
// 一级菜单：Sunglasses
// 二级菜单：Shop by
// 三级菜单：Best Sellers

const LeftSideNav = ({ navData }: SideNavProps) => {
  const isOpen = useStore((state) => state.isOpenSideNav);
  const setIsOpenSideNav = useStore((state) => state.setIsOpenSideNav);
  const { trackEvent } = useReporting();
  const { cnName } = useRouteMetadata();

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      trackEvent(
        {
          eventName: 'SideNavBar_Exp',
          properties: {
            page_name: cnName,
            url_path: window.location.href,
          },
        },
        [ProviderType.SENSORS],
      );
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [isOpen]);

  return (
    <>
      {/* 遮罩层 */}
      {isOpen && (
        <div
          className="fixed h-[100vh] inset-0 bg-[rgba(0,0,0,0.5)] z-[360] overscroll-none touch-none"
          onClick={() => setIsOpenSideNav(false)}
          onTouchMove={(e) => e.preventDefault()}
        />
      )}

      {/* 侧边栏 */}
      <div
        className={`fixed top-0 left-0 h-full w-[80vw] bg-white z-[365] transform transition-transform duration-300 ease-in-out ${
          isOpen ? 'translate-x-0' : '-translate-x-full'
        } flex flex-col overflow-y-auto`}
        style={{
          overscrollBehavior: 'contain',
          touchAction: 'pan-y',
        }}
      >
        {/* 导航菜单部分 */}
        <div className="flex-1">
          {navData.map((item, index) => (
            <MobileMenuItem
              key={item.id}
              item={item}
              firstLevelIndex={index}
              firstLevelTitle={item.content.nav_name}
            />
          ))}
        </div>
        {/* 底部配置部分 */}
        <SiteConfig isWeb={false} />
      </div>
    </>
  );
};

export default LeftSideNav;
